import React from 'react';
import {classes} from './SkeletonRow.st.css';

export const SkeletonRow = ({children}: {children: React.ReactNode}) => <div className={classes.row}>{children}</div>;
